/*
 * @Description: 公共参数
 */

module.exports = {
  baseURL: 'https://michata.us.cc/chat',
  socketUrl: 'https://michata.us.cc/chat',
  whiteList: [
  ],
};
